module.exports = __webpack_public_path__ + "static/media/logo.461b19c8.png";